const parseMarkdownToHTML = (input: string): string => {
  // Regex for bold (double asterisk or underscore)
  const boldRegex = /(\*\*|__)(.*?)\1/g
  // Regex for links [text](url)
  const linkRegex = /\[(.*?)\]\((.*?)\)/g

  // Replace markdown syntax with HTML tags
  const output = input
    .replace(boldRegex, '<strong>$2</strong>')
    .replace(linkRegex, '<a target="_blank" rel="noopener noreferrer" href="$2">$1</a>')

  return output
}

export default parseMarkdownToHTML
